<template>
    <div>
        <v-dialog v-model="showDialog" @click:outside="closeDialog" persistent max-width="400px">
            <v-card>
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Want to switch AI model?</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-row>
                        <v-col>
                            <v-btn @click="switchModel('Open AI')" class="text-capitalize" outlined>Open
                                AI</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn @click="switchModel('Gemini AI')" class="text-capitalize" outlined>Gemini AI</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'ModelSelection',
    methods: {
        switchModel(value) {
            this.$store.dispatch('dashboard/setSelectedAi', value)
            this.$store.dispatch('dashboard/setAiSelectionWindow', false)
        },
        closeDialog() {
            this.$store.dispatch('dashboard/setAiSelectionWindow', false)
        },
    },
    computed: {
        showDialog() {
            return this.$store.getters['dashboard/aiSelectionWindow']
        },
    }
}
</script>